import type { AutoCandidate } from "@opus-dt/shared-types";
import { useSandboxDraft } from "./hooks/useSandboxDraft";
import { upsertOverride } from "./param-types";

// Aplica os ajustes de um candidato de "Sugerir melhorias" ao RASCUNHO do
// sandbox (marca dirty): para cada máquina do rascunho, casa por sourceMachineId e faz upsert dos
// overrides do candidato (clamp ±25%). Também adota a `baseProfile` (base de cold-start que o
// otimizador usou) como simProfile da máquina, p/ que o valor exibido seja o recomendado REAL
// (base medida × delta) — não `default × delta`. Retorna quantas máquinas foram afetadas.
export function applyCandidateToDraft(candidate: AutoCandidate): number {
  const state = useSandboxDraft.getState();
  const byMachine = new Map<string, AutoCandidate["changes"]>();
  for (const ch of candidate.changes) {
    const list = byMachine.get(ch.machineId) ?? [];
    list.push(ch);
    byMachine.set(ch.machineId, list);
  }
  let applied = 0;
  for (const m of Object.values(state.machines)) {
    const changes = byMachine.get(m.sourceMachineId);
    if (!changes) continue;
    let overrides = m.simOverrides ?? [];
    for (const ch of changes) overrides = upsertOverride(overrides, ch.param, ch.deltaPct);
    const baseProfile = changes.find((ch) => ch.baseProfile)?.baseProfile;
    state.setMachineSim(m.key, {
      ...(baseProfile && { simProfile: baseProfile }),
      simOverrides: overrides,
    });
    applied += 1;
  }
  return applied;
}
